import React, { useState, useEffect } from "react";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { PieChart, Pie, Cell, Legend, Tooltip, ResponsiveContainer } from "recharts";
import {baseUrl, userLocation, ipAddress, userName} from '../Univ.js'

function MisCollection(props) {
  const today = new Date();
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [opData, setOp] = useState([]);
  const [ipData, setIp] = useState([]);
  const [refData, setRef] = useState([]);
  const [dueData, setDue] = useState([]);
  const [iprefData, setIpRef] = useState([]);
  const [filteredOp, setFilteredOp] = useState([]);
  const [filteredIp, setFilteredIp] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#A28CFE", "#FF6666"];

  const handleStartDateChange = (date) => setStartDate(date);
  const handleEndDateChange = (date) => setEndDate(date);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
        const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
        const [opResponse, ipResponse, refResponse, dueResponse, iprefResponse] = await Promise.all([
          axios.get(`${baseUrl}all-collection-view/?start_date=${startDateString}&end_date=${endDateString}&cashier=&mode=&status=2`),
          axios.get(`${baseUrl}all-ip-collection-view/?start_date=${startDateString}&end_date=${endDateString}&cashier=&mode=&status=2`),
          axios.get(`${baseUrl}refund-report-view/?start_date=${startDateString}&end_date=${endDateString}`),
          axios.get(`${baseUrl}due-report-view/?start_date=${startDateString}&end_date=${endDateString}`),
          axios.get(`${baseUrl}ip-refund-report-view/?start_date=${startDateString}&end_date=${endDateString}`),
        ]);
        setOp(opResponse.data);
        setIp(ipResponse.data);
        setRef(refResponse.data);
        setDue(dueResponse.data);
        setIpRef(iprefResponse.data);
        setFilteredOp(opResponse.data); // initialize
        setFilteredIp(ipResponse.data); // initialize
        setIsLoading(false);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, [startDate, endDate]);

  // --- Totals calculation ---
  let TotalCons = 0, TotalLab = 0, TotalInv = 0, TotalMin = 0, TotalRef = 0, TotalDue = 0;
  let TotalIpRef = 0, TotalAdv = 0, TotalIpLab = 0, TotalIpInv = 0;

  opData.forEach(payment => {
    TotalCons += Number(payment.paid || 0);
    TotalLab += Number(payment.lab_paid || 0);
    TotalInv += Number(payment.inv_paid || 0);
    TotalMin += Number(payment.min_paid || 0);
  });
  refData.forEach(payment => TotalRef += Number(payment.refund_amount || 0));
  dueData.forEach(payment => TotalDue += Number(payment.due_amount || 0));
  ipData.forEach(payment => {
    TotalAdv += Number(payment.paid || 0);
    TotalIpLab += Number(payment.lab_paid || 0);
    TotalIpInv += Number(payment.inv_paid || 0);
  });
  iprefData.forEach(payment => TotalIpRef += Number(payment.refund_amount || 0));

  const totalOpTotal = TotalCons + TotalLab + TotalInv + TotalMin;
  const totalIpTotal = TotalAdv + TotalIpLab + TotalIpInv;


  const handlePrint = () => {
    const printContents = document.getElementById('invoice-print').innerHTML;
    const originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    setTimeout(() => window.location.reload(), 1000);
    document.body.innerHTML = originalContents;
  };

  // --- Pie Chart click handlers ---
  const handleOpPieClick = (data) => {
    const key = data.name;
    const filtered = opData.filter(item => {
      if (key === "Consult Fee") return item.paid > 0;
      if (key === "Lab") return item.lab_paid > 0;
      if (key === "Radiology") return item.inv_paid > 0;
      if (key === "Minor") return item.min_paid > 0;
      if (key === "Refund") return refData.some(r => r.refund_amount > 0);
      if (key === "Due Paid") return dueData.some(d => d.due_amount > 0);
      return false;
    });
    setFilteredOp(filtered);
  };

  const handleIpPieClick = (data) => {
    const key = data.name;
    const filtered = ipData.filter(item => {
      if (key === "Advance") return item.paid > 0;
      if (key === "Lab") return item.lab_paid > 0;
      if (key === "Radiology") return item.inv_paid > 0;
      if (key === "Refund") return iprefData.some(r => r.refund_amount > 0);
      return false;
    });
    setFilteredIp(filtered);
  };

  return (
    <section className="container mt-4">
      <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
        <i className="fa-solid fa-calendar-days" aria-hidden="true" style={{color: 'red'}}></i> MIS Dashboard
      </h3>

      {/* Date Pickers */}
      <div className="row">
        <div className="col-md-6">

            <label>Select Date</label>
            <div style={{display:'flex', gap:'10px'}}>
            <DatePicker selected={startDate} onChange={handleStartDateChange} selectsStart startDate={startDate} endDate={endDate} placeholderText="From" dateFormat="dd/MM/yyyy"/>
            <DatePicker selected={endDate} onChange={handleEndDateChange} selectsEnd startDate={startDate} endDate={endDate} minDate={startDate} maxDate={today} placeholderText="To" dateFormat="dd/MM/yyyy"/>
          </div>
        </div>
      </div>

      {/* MIS Table */}
      <div className="table-responsive" id="invoice-print">
        <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>MIS Report</h3>
        <table className="erp-table-modern">

          <tbody>
            <tr><td style={{ fontWeight: 'bold' }}>OP Collection</td><td style={{ fontWeight: 'bold' }}>OP Amount</td></tr>
            <tr><td>Consult Fee</td><td>{TotalCons}</td></tr>
            <tr><td>Lab</td><td>{TotalLab}</td></tr>
            <tr><td>Radiology</td><td>{TotalInv}</td></tr>
            <tr><td>Minor</td><td>{TotalMin}</td></tr>
            <tr><td>Refund</td><td>{TotalRef}</td></tr>
            <tr><td>Due Paid</td><td>{TotalDue}</td></tr>
            <tr><td style={{ fontWeight: 'bold' }}>Total(Cons+Lab+Radiology+Minor)</td><td style={{ fontWeight: 'bold' }}>{totalOpTotal}</td></tr>
            <tr><td style={{ fontWeight: 'bold' }}>IP Collection</td><td style={{ fontWeight: 'bold' }}>IP Amount</td></tr>
            <tr><td>Advance Amount</td><td>{TotalAdv}</td></tr>
            <tr><td>Lab</td><td>{TotalIpLab}</td></tr>
            <tr><td>Radiology</td><td>{TotalIpInv}</td></tr>
            <tr><td>Refund</td><td>{TotalIpRef}</td></tr>
            <tr><td style={{ fontWeight: 'bold' }}>Total(Adv+Lab+Radiology)</td><td style={{ fontWeight: 'bold' }}>{totalIpTotal}</td></tr>
          </tbody>
        </table>

        {/* Pie Charts */}
        <div style={{ display: 'flex', justifyContent: 'space-around', flexWrap: 'wrap', margin: '20px 0' }}>
          {/* OP Pie */}
          <div style={{ width: '400px', height: '400px' }}>
            <h4 className="text-center">OP Collection</h4>
            <ResponsiveContainer>
              <PieChart>
                <Pie
                  data={[
                    { name: "Consult Fee", value: TotalCons },
                    { name: "Lab", value: TotalLab },
                    { name: "Radiology", value: TotalInv },
                    { name: "Minor", value: TotalMin },
                    { name: "Refund", value: TotalRef },
                    { name: "Due Paid", value: TotalDue },
                  ]}
                  dataKey="value"
                  nameKey="name"
                  outerRadius={120}
                  label
                  onClick={handleOpPieClick}
                >
                  {[TotalCons, TotalLab, TotalInv, TotalMin, TotalRef, TotalDue].map((_, index) => (
                    <Cell key={index} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip formatter={(value) => value.toFixed(2)} />
                <Legend verticalAlign="bottom" height={36} />
              </PieChart>
            </ResponsiveContainer>
          </div>

          {/* IP Pie */}
          <div style={{ width: '400px', height: '400px' }}>
            <h4 className="text-center">IP Collection</h4>
            <ResponsiveContainer>
              <PieChart>
                <Pie
                  data={[
                    { name: "Advance", value: TotalAdv },
                    { name: "Lab", value: TotalIpLab },
                    { name: "Radiology", value: TotalIpInv },
                    { name: "Refund", value: TotalIpRef },
                  ]}
                  dataKey="value"
                  nameKey="name"
                  outerRadius={120}
                  label
                  onClick={handleIpPieClick}
                >
                  {[TotalAdv, TotalIpLab, TotalIpInv, TotalIpRef].map((_, index) => (
                    <Cell key={index} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip formatter={(value) => value.toFixed(2)} />
                <Legend verticalAlign="bottom" height={36} />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Filtered Table */}
        <h4 className="text-center mt-4">Filtered OP Records</h4>
        <table className="erp-table-modern">

          <thead style={{backgroundColor:'#007bff', color:'#fff'}}>
            <tr>

              <th>Consult Fee</th>
              <th>Lab</th>
              <th>Radiology</th>
              <th>Minor</th>
            </tr>
          </thead>
          <tbody>
            {filteredOp.map((item, idx) => (
              <tr key={idx}>

                <td>{item.paid || 0}</td>
                <td>{item.lab_paid || 0}</td>
                <td>{item.inv_paid || 0}</td>
                <td>{item.min_paid || 0}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
        <button style={{ padding: '5px 20px', borderRadius: '10px', backgroundColor: '#007bff', color: '#fff' }} onClick={handlePrint}>Print</button>
      </div>
    </section>
  );
}

export default MisCollection;
